import {ICaseStatus, IProsecutionResult, IProsecutionStatus} from "@/constants/interface";

export default {
  status: {
    processing: false,
    error: null,
    success: null,
    previous: null
  },
  lawyer: {},
  lawyers: [],
  lawyerOptions: [],
  prosecution: {},
  prosecutions: [],
  prosecutionDetail: {},
  prosecutionDetails: [],
  prosecutionStatusOptions: Object.keys(IProsecutionStatus).map(key => ({
    value: IProsecutionStatus[key],
  })),
  prosecutionResultOptions: Object.keys(IProsecutionResult).map(key => ({
    value: IProsecutionResult[key],
  })),
  caseStatusOptions: Object.keys(ICaseStatus).map(key => ({
    value: ICaseStatus[key],
  })),
  disabledCaseStatusOptions: [ICaseStatus.draft, ICaseStatus.sendInformationContractToLawyer, ICaseStatus.lawyerAccepted],
  disabledCaseStatusProsecuteCaseOptions: [
    ICaseStatus.draft,
    ICaseStatus.sendInformationContractToLawyer,
    ICaseStatus.lawyerAccepted,

    ICaseStatus.submitForLegalExecution,
    ICaseStatus.issueWarrantForEnforcementOfficer,
    ICaseStatus.submitEnforcementCaseDocument,
    ICaseStatus.announcePublicAuction,
  ],
  disabledCaseStatusEnforceCaseOptions: [
    ICaseStatus.draft,
    ICaseStatus.sendInformationContractToLawyer,
    ICaseStatus.lawyerAccepted,

    ICaseStatus.lawyerSendInquiryLetter,
    ICaseStatus.negotiateWithLawyerForPayment,
    ICaseStatus.fileLawsuit,
    ICaseStatus.courtJudgment,
    ICaseStatus.makeDebtRestructuringContract,
    ICaseStatus.sendEnforcementOrder,
  ],
  endCaseStatus: [ICaseStatus.cancelCase, ICaseStatus.closeCase],
  file: {},
  files: [],
}
